import { observer } from 'mobx-react-lite'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { useDetailsContext } from '../detailsContext'
import { ConversationCard } from './ConversationCard'
import styles from './styles.module.scss'

export const TabConversation = observer(() => {
  const { data } = useDetailsContext()

  const maxAttempts = `${data.settings?.max_attempts?.value ?? '0'}`
  const instructions = data.settings?.instructions?.value
  const useKnowledgeBase = data.settings?.use_knowledge_base?.value ? 'Yes' : 'No'

  return (
    <section className={styles.conversationCards}>
      {data.type === ChatbotInstructionType.LeadQualification && (
        <>
          <ConversationCard
            value={maxAttempts}
            name='Set a message limit'
            placeholder='Message limit'
          />
          <ConversationCard
            value={useKnowledgeBase}
            name='Use knowledge base?'
            placeholder='Knowledge base?'
          />
        </>
      )}
      <ConversationCard
        value={instructions}
        name={
          <>
            Add instructions
            <br key={'br'} />
            for the AI Agent
            <br key={'br'} />
            to follow
          </>
        }
        placeholder='Answer customer questions about store hours, return policies, or product specifications.'
      />
    </section>
  )
})
